import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AppelsRoutingModule } from './appels-routing.module';
import { ListeAppelsComponent } from './components/liste-appels/liste-appels.component';
import { SoumissionsComponent } from './components/soumissions/soumissions.component';
import { CandidaturesComponent } from './components/candidatures/candidatures.component';
import { SharedModule } from '../shared/shared.module';
import { CertificatsComponent } from './components/certificats/certificats.component';
import { Liste2appelsComponent } from './liste2appels/liste2appels.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SIGUIAppelsComponent } from './components/sigui-appels/sigui-appels.component';
import { DeliberationComponent } from './components/deliberation/deliberation.component';
import { AdmisComponent } from './components/admis/admis.component';
import { NonadmisComponent } from './components/nonadmis/nonadmis.component';
import { DashBoardSiguiComponent } from '../main-layout/components/dash-board-sigui/dash-board-sigui.component';
import { SiguiComponent } from './components/sigui/sigui.component';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { StatisticsComponent } from './components/statistics/statistics.component';
import { TestComponent } from './components/test/test.component';
import { NewCertificateComponent } from './components/new-certificate/new-certificate.component';
import { SiguiCertificatsComponent } from './components/sigui-certificats/sigui-certificats.component';
import { MatTabsModule } from '@angular/material/tabs';
import { HorsiguiAppelsComponent } from './components/horsigui-appels/horsigui-appels.component';
import { CandidatureHorsParcoursComponent } from './components/candidature-hors-parcours/candidature-hors-parcours.component';
import { HorsSiguiCertificateComponent } from './components/hors-sigui-certificate/hors-sigui-certificate.component';
import { HorsiguiStatComponent } from './components/horsigui-stat/horsigui-stat.component';
import { HorsiguiAdmiComponent } from './components/horsigui-admi/horsigui-admi.component';
import { MatSelectModule } from '@angular/material/select';
import { CourseraAppelsComponent } from './components/coursera-appels/coursera-appels.component';
import { CourseraStatsComponent } from './components/coursera-stats/coursera-stats.component';
import { CourseraDashboardComponent } from './components/coursera-dashboard/coursera-dashboard.component';
import { CourseraGenreChartComponent } from './components/coursera-dashboard/coursera-genre-chart/coursera-genre-chart.component';
import { CourseraHandicapChartComponent } from './components/coursera-dashboard/coursera-handicap-chart/coursera-handicap-chart.component';
import { CourseraPaysChartComponent } from './components/coursera-dashboard/coursera-pays-chart/coursera-pays-chart.component';
import { CourseraDiplomeChartComponent } from './components/coursera-dashboard/coursera-diplome-chart/coursera-diplome-chart.component';
import { CourseraStatutChartComponent } from './components/coursera-dashboard/coursera-statut-chart/coursera-statut-chart.component';
import { CourseraMigrationChartComponent } from './components/coursera-dashboard/coursera-migration-chart/coursera-migration-chart.component';
import { RapportModule } from '../rapport/rapport.module';
import { StatconnectionComponent } from './components/statconnection/statconnection.component';
import { StatconnectionHPComponent } from './components/statconnection-hp/statconnection-hp.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [
    ListeAppelsComponent,
    SoumissionsComponent,
    CandidaturesComponent,
    CertificatsComponent,
    Liste2appelsComponent,
    SIGUIAppelsComponent,
    DeliberationComponent,
    AdmisComponent,
    NonadmisComponent,
    SiguiComponent,
    StatisticsComponent,
    TestComponent,
    NewCertificateComponent,
    SiguiCertificatsComponent,
    HorsSiguiCertificateComponent,
    CandidatureHorsParcoursComponent,
    HorsiguiAppelsComponent,
    HorsiguiStatComponent,
    HorsiguiAdmiComponent,
    CourseraAppelsComponent,
    CourseraStatsComponent,
    CourseraDashboardComponent,
    CourseraGenreChartComponent,
    CourseraHandicapChartComponent,
    CourseraPaysChartComponent,
    CourseraDiplomeChartComponent,
    CourseraStatutChartComponent,
    CourseraMigrationChartComponent,
    StatconnectionComponent,
    StatconnectionHPComponent,
  ],
  imports: [
    CommonModule,
    AppelsRoutingModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatTableModule,
    MatInputModule,
    MatIconModule,
    MatPaginatorModule,
    MatSelectModule,
    RapportModule
  ],
})
export class AppelsModule { }
